import React, { useState } from "react";
import style from "./Details.module.scss";
import CaretDown24 from "../../../../assets/svg/icons/common/CaretDown24";
import CaretRight24 from "../../../../assets/svg/icons/common/CaretRight24";
import CheckMarkGreen from "../../../../assets/svg/icons/common/CheckMarkGreen";
import CrossIconRed from "../../../../assets/svg/icons/common/CrossIconRed";
import { useMediaQuery } from "../../../../hooks/useMediaQuery";
import { isMultipleLocations } from "../../../../../components/helper/helper";
import MultiLocationDetailRows from "../../../../components/MultiLocationDetailRows";

function BusinessProfile({ appData, expandAppDetails }) {
  const [isOpen, setIsOpen] = useState(false);
  const isMobile = useMediaQuery(768);
  const profile = appData?.powerappbusinessprofile;

  const renderYesNo = (value) => {
    if (value !== "" && value !== undefined && value !== null) {
      const normalized = String(value).toLowerCase();
      return normalized === "yes" || normalized === "true" ? (
        <>
          <CheckMarkGreen /> Yes
        </>
      ) : (
        <>
          <CrossIconRed /> No
        </>
      );
    }
    return "-";
  };

  return (
    <div
      className={`${style.accordion_item} ${style.business_profile_section} ${expandAppDetails ? style.expanded : ""}`}
    >
      <div
        className={`${style.accordion_head} ${isOpen ? style.open : ""}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        {isMobile ? (
          <CaretRight24 className={`${style.caret_icon} ${isOpen ? style.expended : ""}`} />
        ) : (
          <CaretDown24 />
        )}
        <h5>Business Profile</h5>
      </div>
      {isOpen && (
        <div className={`${style.accordion_body} ${isMobile && isOpen ? style.expanded : ""}`}>
          <>
            <div className={style.data_item}>
                <p className={style.data_label}>
                  Products and services description
                </p>
                <p className={style.data_value}>
                  {appData?.powerappbusinessprofile?.product_service_sold || "-"}
                </p>
              </div>
              <div className={style.data_item}>
                <p className={style.data_label}>
                  Products and/or services are advertised
                </p>
                <p className={style.data_value}>
                  {appData?.powerappbusinessprofile?.prod_advertise_desc || "-"}
                </p>
              </div>
              <div className={style.data_item}>
                <p className={style.data_label}>
                  3rd party application involved with payment process
                </p>
                <p className={style.data_value}>
                  {renderYesNo(appData?.powerappbusinessprofile?.thirdparty_delivered_radio)}
                </p>
              </div>
              <div className={style.data_item}>
                <p className={style.data_label}>
                  Business or any associated owner ever been terminated as a
                  VISA/MasterCard/Discover/AMEX merchant?
                </p>
                <p className={style.data_value}>
                  {renderYesNo(appData?.creditcardprocess?.terminated_as_vmdax)}
                </p>
              </div>
              <div className={style.data_item}>
                <p className={style.data_label}>
                  Business had any ongoing or prior data compromise investigations
                </p>
                <p className={style.data_value}>
                  {renderYesNo(appData?.creditcardprocess?.prior_data_compromise_invetigation ?? appData?.powerappbusinessprofile?.prior_data_compromise_invetigation)}
                </p>
              </div>
              <div className={style.data_item}>
                <p className={style.data_label}>
                  Business was previously identified with Visa Risk Programs
                </p>
                <p className={style.data_value}>
                  {renderYesNo(appData?.creditcardprocess?.identified_visa_risk_program)}
                </p>
              </div>
              <div className={style.data_item}>
                <p className={style.data_label}>Multiple locations</p>
                <p className={style.data_value}>
                  {renderYesNo(profile?.is_multiple_locations)}
                </p>
              </div>
              {isMultipleLocations(profile?.is_multiple_locations) && (
                <MultiLocationDetailRows
                  multiMerchant={profile?.multi_merchant}
                  multiMerchantOf={profile?.multi_merchant_of}
                  additionalLocation={profile?.additional_location}
                  additionalLocationOf={profile?.additional_location_of}
                  itemClassName={style.data_item}
                  labelClassName={style.data_label}
                  valueClassName={style.data_value}
                />
              )}
          </>
        </div>
      )}
    </div>
  );
}

export default BusinessProfile;
